import { getAssetUrl } from "@utils/getAssetUrl";
import type { ShareCampaignBuilder } from "../types";

// 導流連結：測試站僅在 REACT_APP_NODE_ENV === "development" 時使用，其餘皆為正式站
const redirectUrl =
	process.env.REACT_APP_NODE_ENV === "development"
		? "https://maac.io/6fySP"
		: "https://maac.io/6fyYx";

const heroImage = getAssetUrl(
	"/images/share/SummerSplash2026CampaignFlex/image_1.jpg",
);

export const buildSummerSplash2026CampaignFlex: ShareCampaignBuilder = (
	lineDisplayName,
) => {
	const text =
		`${lineDisplayName}邀請你一同參加測驗，並發掘您的專屬夏日 Splash 時尚風格。\n\n` +
		`點擊下方圖片，立即開啟你的夏日探索。`;

	return [
		// 上：文字訊息
		{
			type: "text",
			text,
		},
		// 下：圖片（整張可點 → 導流連結）
		{
			type: "flex",
			altText: text,
			contents: {
				type: "bubble",
				size: "giga",
				hero: {
					type: "image",
					url: heroImage,
					size: "full",
					aspectMode: "cover",
					aspectRatio: "1:1",
					action: {
						type: "uri",
						label: "開始測驗",
						uri: redirectUrl,
					},
				},
			},
		},
	];
};
